import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import DPSelect from "Components/DP/DPSelect/DPSelect";
import useStyles from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/StatementsTab/PayPeriodHeader/PayPeriodSelector/styles";
import pretty, { DateOptions } from "Shared/pretty";
import { DPPartialPayPeriod } from "Shared/types/EmployeeProfiles";

const dateOptions: DateOptions = {
  format: "MM/DD/YY",
  utc: true,
};

export interface PayPeriodSelectorProps {
  selectedIndex: number;
  onIndexChanged: (index: number) => void;
  payPeriods: DPPartialPayPeriod[];
}

const PayPeriodSelector = ({
  selectedIndex,
  onIndexChanged,
  payPeriods,
}: PayPeriodSelectorProps) => {
  const classes = useStyles();
  return (
    <DPSelect
      inputLabel="Pay Period:"
      inputLabelProps={{
        classes: {
          root: classes.label,
        },
      }}
      selectedIndex={selectedIndex}
      onIndexChanged={onIndexChanged}
    >
      {payPeriods.map((payPeriod, idx) => (
        <MenuItem key={idx} value={idx}>
          <span>{`${pretty.date(payPeriod.startsAt, dateOptions)}`}</span>
          <span className={classes.toLabel}>to</span>
          <span>{`${pretty.date(payPeriod.endsAt, dateOptions)}`}</span>
        </MenuItem>
      ))}
    </DPSelect>
  );
};

export default PayPeriodSelector;
